import { Pipe, PipeTransform } from '@angular/core';
import { IPolygonPoint } from '../interfaces';
import { ShapeManager } from '../managers';

@Pipe({
  name: 'pointsToPolygon'
})
export class PointsToPolygonPipe implements PipeTransform {

  public transform(pointsArray: IPolygonPoint[]): string[] {
    if (!pointsArray || pointsArray?.length === 0) {
      return [];
    }

    const polygons = [];

    for (const polygonPoints of ShapeManager.getShapePartsPolygonsPoints(pointsArray)) {
      if (polygonPoints.length > 0) {
        polygons.push(ShapeManager.formatPolygonFromPoints(polygonPoints));
      }
    }

    return polygons;
  }
}
